// extracted by mini-css-extract-plugin
module.exports = {"chartFooterRoot":"zbvvQUL4","footerItem":"s21bQwU7"};